//#region Object prototype changes

if (!Object.size) {
    // This extension will return the size of an object (note, this can get expensive - use wisely.  i.e. if you are iterating and checking sizes, get a handle of the size of the object before the itteration...AL
    Object.size = function (obj) {
        var size = 0, key;
        for (key in obj) {
            if (obj.hasOwnProperty(key)) size++;
        }
        return size;
    };
}

//#endregion

//#region Array Extensions
/**
 * The code used for the sortMerge() method of array prototypes is sourced from StackExchange
 *
 * http://codereview.stackexchange.com/questions/87000/fast-merge-sort-in-javascript
 *
 * and as such the code for this method is licensed under Creative Commons
 * Attribution-ShareAlike license version 3.0 Unported (CC BY-SA 3.0):
 * http://stackexchange.com/legal
 *
 * You are free to:
 * Share — copy and redistribute the material in any medium or format
 * Adapt — remix, transform, and build upon the material
 * for any purpose, even commercially.
 *
 * The licensor cannot revoke these freedoms as long as you follow the license terms.
 *
 * Under the following terms:
 *  * Attribution — You must give appropriate credit, provide a link to the license, and indicate
 *    if changes were made. You may do so in any reasonable manner, but not in any way that
 *    suggests the licensor endorses you or your use.
 *  * ShareAlike — If you remix, transform, or build upon the material, you must distribute your
 *    contributions under the same license as the original.
 *  * No additional restrictions — You may not apply legal terms or technological measures that
 *    legally restrict others from doing anything the license permits.
 *
 * Notices:
 * You do not have to comply with the license for elements of the material in the public domain
 * or where your use is permitted by an applicable exception or limitation.
 * No warranties are given. The license may not give you all of the permissions necessary for your
 * intended use. For example, other rights such as publicity, privacy, or moral rights may limit
 * how you use the material.
 *
 * NOTICE OF USE: This code was *not* adapted from its presented form; since the ShareAlike
 * provision has not been triggered (as the material has not been remixed, transformed or built
 * upon, but merely used), other code does not have to be licensed under CC BY-SA 3.0.
 */
var mergesort = function (array, /* optional */ cmp) {
    /*
     Merge sort.
     On average, two orders of magnitude faster than Array.prototype.sort() for
     large arrays, with potentially many equal elements.
     Note that the default comparison function does not coerce its arguments to strings.
     */

    if (cmp === undefined) {
        // Note: This is not the same as the default behavior for Array.prototype.sort(),
        // which coerces elements to strings before comparing them.
        cmp = function (a, b) {
            return a < b ? -1 : a === b ? 0 : 1;
        };
    }

    function merge(begin, begin_right, end) {
        // Create a copy of the left and right halves.
        var left_size = begin_right - begin, right_size = end - begin_right;
        var left = array.slice(begin, begin_right), right = array.slice(begin_right, end);
        // Merge left and right halves back into original array.
        var i = begin, j = 0, k = 0;
        while (j < left_size && k < right_size)
            if (cmp(left[j], right[k]) <= 0)
                array[i++] = left[j++];
            else
                array[i++] = right[k++];
        // At this point, at least one of the two halves is finished.
        // Copy any remaining elements from left array back to original array.
        while (j < left_size) array[i++] = left[j++];
        // Copy any remaining elements from right array back to original array.
        while (k < right_size) array[i++] = right[k++];
        return;
    }

    function msort(begin, end) {
        var size = end - begin;
        if (size <= 8) {
            // By experimentation, the sort is fastest when using native sort for
            // arrays with a maximum size somewhere between 4 and 16.
            // This decreases the depth of the recursion for an array size where
            // O(n^2) sorting algorithms are acceptable.
            var sub_array = array.slice(begin, end);
            sub_array.sort(cmp);
            // Copy the sorted array back to the original array.
            for (var i = 0; i < size; ++i)
                array[begin + i] = sub_array[i];
            return;
        }

        var begin_right = begin + (size >> 1);

        msort(begin, begin_right);
        msort(begin_right, end);
        merge(begin, begin_right, end);
    }

    msort(0, array.length);

    return array;
};

if (!Array.prototype.sortMerge) {
    Object.defineProperties(Array.prototype, {
        sortMerge: {
            value: function (cmp) {
                // use the mergesort function to sort the array.
                mergesort(this, cmp);
                return this;
            },
            enumerable: false
        }
    });
}

if (!Array.prototype.indexOf) {
    Object.defineProperties(Array.prototype, {
        indexOf: {
            value: function (searchElement) {
                if (this == null) {
                    throw new TypeError();
                }

                var t = Object(this), len = t.length >>> 0;
                if (len === 0) return -1;

                var n = 0;
                if (arguments.length > 0) {
                    n = Number(arguments[1]);
                    if (n != n) n = 0;
                    else if (n !== 0 && n != Infinity && n != -Infinity) {
                        n = (n > 0 || -1) * ~~Math.abs(n);
                    }
                }
                if (n >= len) return -1;
                var k = n >= 0 ? n : Math.max(len - Math.abs(n), 0);
                for (; k < len; k++) {
                    if (k in t && t[k] === searchElement) return k;
                }
                return -1;
            },
            enumerable: false
        }
    });
}

if (!Array.prototype.repeat) {
    Object.defineProperties(Array.prototype, {
        repeat: {
            value: function (length, value, isFactory) {
                if (!isFactory || isFactory == false)
                    while (length) { this[--length] = value; }
                else
                    while (length) { this[--length] = value(); }
                return this;
            },
            enumerable: false
        }
    });
}

if (!Array.prototype.swap) {
    Object.defineProperties(Array.prototype, {
        swap: {
            value: function (firstIndex, secondIndex) {
                var t = this[firstIndex];
                this[firstIndex] = this[secondIndex];
                this[secondIndex] = t;
                return this;
            },
            enumerable: false
        }
    });
}

if (!Array.isArray) {
    Array.isArray = function (a) {
        return Object.prototype.toString.call(a) == '[object Array]';
    };
}

if (!Array.prototype.where) {
    Object.defineProperties(Array.prototype, {
        where: {
            value: function (selectWhen) {
                var whereList = [];
                for (var i = 0, ilimit = this.length; i < ilimit; i++) {
                    var checkObj = this[i];
                    if (selectWhen(checkObj) == true) {
                        whereList.push(checkObj);
                    }
                }
                return whereList;
            },
            enumerable: false
        }
    });
}

if (!Array.prototype.any) {
    Object.defineProperties(Array.prototype, {
        any: {

            /**
             * Checks through the array using the specified boolean function until a match is found
             * @param whereClause {function} The check case function, should return a boolean value
             * @returns {boolean} true if the function returns true on any item in the array, false if no matches were found
             */
            value: function (whereClause) {
                if (whereClause == null && this.length > 0) return true;

                for (var i = 0, ilimit = this.length; i < ilimit; i++) {
                    if (whereClause(this[i]) == true) {
                        return true
                    }
                }
                return false;
            },
            enumerable: false
        }
    });
}

if (!Array.prototype.first) {
    Object.defineProperties(Array.prototype, {
        first: {
            value: function () {
                if (this.length > 0)
                    return this[0];
                else
                    return null;
            },
            enumerable: false
        }
    });
}

if (!Array.prototype.last) {
    Object.defineProperties(Array.prototype, {
        last: {
            value: function () {
                if (this.length > 0)
                    return this[this.length - 1];
                else
                    return null;
            },
            enumerable: false
        }
    });
}

if (!Array.prototype.max) {
    Object.defineProperties(Array.prototype, {
        max: {
            value: function () {
                var max = null;
                for (var i = 0, ilimit = this.length; i < ilimit; i++) {
                    if (this[i] > max)
                        max = this[i];
                }
                return max;
            },
            enumerable: false
        }
    });
}

if (!Array.prototype.min) {
    Object.defineProperties(Array.prototype, {
        min: {
            value: function () {
                var min = null;
                for (var i = 0, ilimit = this.length; i < ilimit; i++) {
                    if (this[i] < min)
                        min = this[i];
                }
                return min;
            },
            enumerable: false
        }
    });
}

if (!Array.prototype.sum) {
    Object.defineProperties(Array.prototype, {
        sum: {
            value: function () {
                return this.reduce((acc, val) => acc + val, 0);
            },
            enumerable: false
        }
    });
}

if (!Array.prototype.select) {
    Object.defineProperties(Array.prototype, {
        select: {
            value: function (selectorFunction) {
                var selectionArray = [];
                for (var i = 0, ilimit = this.length; i < ilimit; i++) {
                    selectionArray.push(selectorFunction(this[i]));
                }
                return selectionArray;
            },
            enumerable: false
        }
    });
}

if (!Array.prototype.selectMany) {
    Object.defineProperties(Array.prototype, {
        selectMany: {
            value: function (selectManyFunction) {
                var selectionArray = [];
                for (var i = 0, ilimit = this.length; i < ilimit; i++) {
                    selectionArray = selectionArray.concat(selectManyFunction(this[i]));
                }
                return selectionArray;
            },
            enumerable: false
        }
    });
}

if (!Array.prototype.distinct) {
    Object.defineProperties(Array.prototype, {
        distinct: {
            value: function (includeBlank) {
                if (includeBlank == undefined) includeBlank = true;

                // Create an array to hold the distinct items..PW
                var distinctList = [];
                var attrToAdd = null;   // init var to hold the attribute..PW

                // Iterate through each object in the source array, find it, and add it if missing..PW
                for (var i = 0, ilimit = this.length; i < ilimit; i++) {
                    attrToAdd = this[i];    // Get the attribute to check/add..PW

                    if (attrToAdd == null) attrToAdd = "";      //Mark any null references as zero-length strings...EK
                    if (attrToAdd != "" || includeBlank) {
                        if (distinctList.indexOf(attrToAdd) == -1)
                        // Item not found in distinctList, add it..PW
                            distinctList.push(attrToAdd);
                    }
                }

                return distinctList;    // Return the distinct list of items..PW
            },
            enumerable: false
        }
    })
}

if (!Array.prototype.move) {
    Object.defineProperties(Array.prototype, {
        move: {
            value: function (old_index, new_index) {
                if (this.length == 0 || new_index < 0 || new_index == this.length) return false;        //Wrap these scenarios where no movement would actually occur...EK

                if (new_index > this.length) {
                    var k = new_index - this.length;
                    while ((k--) + 1) {
                        this.push(undefined);
                    }
                }
                this.splice(new_index, 0, this.splice(old_index, 1)[0]);
                return true;
            },
            enumerable: false
        }
    });
}

if (!Array.prototype.replace) {
    Object.defineProperties(Array.prototype, {
        replace: {
            value: function (fromObj, toObj) {
                if (this.length == 0) return false;

                var fromPos = this.indexOf(fromObj);
                if (fromPos == -1) return false;

                this[fromPos] = toObj;

                return true;
            },
            enumerable: false
        }
    });
}

if (!Array.prototype.remove) {
    Object.defineProperties(Array.prototype, {
        remove: {
            value: function (objRef) {
                if (this.length == 0) return false;

                var fromPos = this.indexOf(objRef);
                if (fromPos == -1) return false;

                this.splice(fromPos, 1);

                return true;
            },
            enumerable: false
        }
    });
}

if (!Array.prototype.removeAt) {
    Object.defineProperties(Array.prototype, {
        removeAt: {
            value: function (index) {
                if (this.length == 0) return false;
                if (index > this.length) return false;

                this.splice(index, 1);

                return true;
            },
            enumerable: false
        }
    });
}

if (!Array.prototype.insert) {
    Object.defineProperties(Array.prototype, {
        insert: {
            value: function (index, array) {
                var args = [];
                args.push(index);
                args.push(0);
                args = args.concat(array);
                this.splice.apply(this, args);
                return this;
            },
            enumerable: false
        }
    });
}

if (!Array.prototype.average) {
    Object.defineProperties(Array.prototype, {
        average: {
            value: function () {
                if (this.length > 0) {
                    return this.sum() / this.length;
                }
                else {
                    return 0;
                }
            },
            enumerable: false
        }
    })
}

// Production steps of ECMA-262, Edition 5, 15.4.4.17
// Reference: http://es5.github.io/#x15.4.4.17
if (!Array.prototype.some) {
    Object.defineProperties(Array.prototype, {
        some: {
            value: function(someSelector) {
                'use strict';

                if (this == null) {
                    throw new TypeError('Array.prototype.some called on null or undefined');
                }

                if (typeof fun !== 'function') {
                    throw new TypeError();
                }

                var t = Object(this);
                var len = t.length >>> 0;

                var thisArg = arguments.length >= 2 ? arguments[1] : void 0;
                for (var i = 0; i < len; i++) {
                    if (i in t && someSelector.call(thisArg, t[i], i, t)) {
                        return true;
                    }
                }

                return false;
            },
            enumerable: false
        }
    });
}

// #endregion

//#region String

// add 'startsWith' property to String object to return if string starts with specified string.
// NOTE: slice is used instead of 'indexOf' as it is O(1) instead of O(n) (ie - constant time regardless of string length).
//       http://stackoverflow.com/questions/646628/how-to-check-if-a-string-startswith-another-string
if (!String.prototype.startsWith) {
    Object.defineProperties(String.prototype, {
        startsWith: {
            value: function (prefix) {
                return this.slice(0, prefix.length) == prefix;
            },
            enumerable: false
        }
    });
}

// add 'endsWith' property to String object to return if string ends with specified string.
// NOTE: slice is used instead of 'lastIndexOf' as it is O(1) instead of O(n) (ie - constant time regardless of string length).
//       http://stackoverflow.com/questions/646628/how-to-check-if-a-string-startswith-another-string
if (!String.prototype.endsWith) {
    Object.defineProperties(String.prototype, {
        endsWith: {
            value: function (suffix) {
                return this.slice(-suffix.length) == suffix;
            },
            enumerable: false
        }
    });
}

// add 'contains' property to String object to return if string contains specified string.
if (!String.prototype.contains) {
    Object.defineProperties(String.prototype, {
        contains: {
            value: function (str) {
                return this.indexOf(str) != -1;
            },
            enumerable: false
        }
    });
}

// add 'contains' property to String object to return if string contains specified string.
if (!String.prototype.getAllIndexesOf) {
    String.prototype.getAllIndexesOf = function (char) {
        var re = new RegExp(char, "g"),
            resArr = [],
            match;
        while (match = re.exec(this))
            resArr.push(match.index);

        return resArr;
    }
}

// Add slashes to characters that need escaped...AL
if (!String.prototype.escapeChars) {
    String.prototype.escapeChars = function () {
        return this.replace(/[\[\]\\"']/g, '\\$&').replace(/\u0000/g, '\\0');
    };
}

// Insert a string a particular index...AL
if (!String.prototype.insert) {
    String.prototype.insert = function (index, string) {
        if (index > 0)
            return this.substring(0, index) + string + this.substring(index, this.length);
        else
            return string + this;
    };
}

if (!String.prototype.trim) {
    Object.defineProperties(String.prototype, {
        trim: {
            value: function () { return this.replace(/^\s+|\s+$/g, ''); },
            enumerable: false
        }
    });
}

// First, checks if it isn't implemented yet.
if (!String.format) {
    String.format = function (format) {
        let args = Array.prototype.slice.call(arguments, 1);
        return format.replace(/{(\d+)}/g, function (match, number) {
            return typeof args[number] !== 'undefined'
                ? args[number]
                : match;
        });
    };
}

/**
 * Convert a string to proper case...EG
 */
if (!String.prototype.toProperCase){
    String.prototype.toProperCase = function(opt_lowerCaseTheRest) {
        return (opt_lowerCaseTheRest ? this.toLowerCase() : this)
            .replace(/(^|[\s\xA0])[^\s\xA0]/g, function(s){ return s.toUpperCase(); });
    };
}

//#endregion

//#region Number
if (!Number.isInteger) {
    Number.isInteger = function (value) {
        return typeof value === 'number' &&
            isFinite(value) &&
            Math.floor(value) === value;
    };
}


if (!Number.isNumeric) {
    /**
     * Checks if the given value is a valid number
     * @param {*} value - The value to check
     * @returns {boolean} True if the value is a number, false otherwise
     */
    Number.isNumeric = function (value) {
        return !isNaN(parseFloat(value)) && isFinite(value);
    }
}

//#endregion

//#region SVGElement

if (!SVGElement.outerHTML) {
    Object.defineProperty(SVGElement.prototype, 'outerHTML', {
        get: function () {
            var $node, $temp;
            $temp = document.createElement('div');
            $node = this.cloneNode(true);
            $temp.appendChild($node);
            return $temp.innerHTML;
        },
        enumerable: false,
        configurable: true
    });
}

//#endregion

//#region JSON

/*
 * Adapted from Crockford's JSON.parse (see https://github.com/douglascrockford/JSON-js)
 * This version adds support for NaN, -Infinity and Infinity.
 * License
 * Public Domain. Use as you wish and at your own risk.
 */
(function(){
    let at,	 // The index of the current character
        ch,	 // The current character
        escapee = {
            '"':  '"',
            '\\': '\\',
            '/':  '/',
            b:	'\b',
            f:	'\f',
            n:	'\n',
            r:	'\r',
            t:	'\t'
        },
        text,
        error = function (m) {
            throw {
                name: 'SyntaxError',
                message: m,
                at:	at,
                text: text
            };
        },
        next = function (c) {
            return ch = text.charAt(at++);
        },
        check = function (c) {
            if (c !== ch) {
                error("Expected '" + c + "' instead of '" + ch + "'");
            }
            ch = text.charAt(at++);
        },
        number = function () {
            let string = '';
            if (ch === '-') {
                string = '-';
                check('-');
            }
            if (ch === 'I') {
                check('I');
                check('n');
                check('f');
                check('i');
                check('n');
                check('i');
                check('t');
                check('y');
                return -Infinity;
            }
            while (ch >= '0' && ch <= '9') {
                string += ch;
                next();
            }
            if (ch === '.') {
                string += '.';
                while (next() && ch >= '0' && ch <= '9') {
                    string += ch;
                }
            }
            if (ch === 'e' || ch === 'E') {
                string += ch;
                next();
                if (ch === '-' || ch === '+') {
                    string += ch;
                    next();
                }
                while (ch >= '0' && ch <= '9') {
                    string += ch;
                    next();
                }
            }
            return +string;
        },
        string = function () {
            let hex,
                i,
                string = '',
                uffff;
            if (ch === '"') {
                while (next()) {
                    if (ch === '"') {
                        next();
                        return string;
                    }
                    if (ch === '\\') {
                        next();
                        if (ch === 'u') {
                            uffff = 0;
                            for (i = 0; i < 4; i ++) {
                                hex = parseInt(next(), 16);
                                if (!isFinite(hex)) {
                                    break;
                                }
                                uffff = uffff * 16 + hex;
                            }
                            string += String.fromCharCode(uffff);
                        } else if (escapee[ch]) {
                            string += escapee[ch];
                        } else {
                            break;
                        }
                    } else {
                        string += ch;
                    }
                }
            }
            error("Bad string");
        },
        white = function () { // Skip whitespace.
            while (ch && ch <= ' ') {
                next();
            }
        },
        word = function () {
            switch (ch) {
                case 't':
                    check('t');
                    check('r');
                    check('u');
                    check('e');
                    return true;
                case 'f':
                    check('f');
                    check('a');
                    check('l');
                    check('s');
                    check('e');
                    return false;
                case 'n':
                    check('n');
                    check('u');
                    check('l');
                    check('l');
                    return null;
                case 'N':
                    check('N');
                    check('a');
                    check('N');
                    return NaN;
                case 'I':
                    check('I');
                    check('n');
                    check('f');
                    check('i');
                    check('n');
                    check('i');
                    check('t');
                    check('y');
                    return Infinity;
            }
            error("Unexpected '" + ch + "'");
        },
        array = function () {
            let array = [];
            if (ch === '[') {
                check('[');
                white();
                if (ch === ']') {
                    check(']');
                    return array;   // empty array
                }
                while (ch) {
                    array.push(value());
                    white();
                    if (ch === ']') {
                        check(']');
                        return array;
                    }
                    check(',');
                    white();
                }
            }
            error("Bad array");
        },
        object = function () {
            let key, object = {};
            if (ch === '{') {
                check('{');
                white();
                if (ch === '}') {
                    check('}');
                    return object;   // empty object
                }
                while (ch) {
                    key = string();
                    white();
                    check(':');
                    if (Object.hasOwnProperty.call(object, key)) {
                        error('Duplicate key "' + key + '"');
                    }
                    object[key] = value();
                    white();
                    if (ch === '}') {
                        check('}');
                        return object;
                    }
                    check(',');
                    white();
                }
            }
            error("Bad object");
        };
    let value = function () {
        white();
        switch (ch) {
            case '{':
                return object();
            case '[':
                return array();
            case '"':
                return string();
            case '-':
                return number();
            default:
                return ch >= '0' && ch <= '9' ? number() : word();
        }
    };

    if (!JSON.parseMore) {
        /**
         *
         * @param {String} source - The string to parse
         * @param {Function} reviver - A function to process against the string for specific replacements.
         * @returns {*|void}
         */
        JSON.parseMore = function (source, reviver) {
            if (source == null || source === '') {
                // if null or an empty string is supplied to be parsed, return null.
                return null;
            }

            let result;
            text = source;
            at = 0;
            ch = ' ';
            result = value();
            white();
            if (ch) {
                error("Syntax error");
            }
            return typeof reviver === 'function'
                ? (function walk(holder, key) {
                    let k, v, value = holder[key];
                    if (value && typeof value === 'object') {
                        for (k in value) {
                            if (Object.prototype.hasOwnProperty.call(value, k)) {
                                v = walk(value, k);
                                if (v !== undefined) {
                                    value[k] = v;
                                } else {
                                    delete value[k];
                                }
                            }
                        }
                    }
                    return reviver.call(holder, key, value);
                }({'': result}, ''))
                : result;
        };
    }
})();

//#endregion
